import { ENDPIONTS, PaginatedResult } from "@api";
import { useFetch } from "@hooks";
import { ComplexHeader, Table } from "@shared";
import { PayrollSuspensionResponseDTO } from "@viewModels";
import { useEffect } from "react";

interface Props {
  payrollId: string | number;
}
const PayrollSuspensions = ({ payrollId }: Props) => {
  const fetchData = useFetch<PaginatedResult<PayrollSuspensionResponseDTO>>(
    {
      endPoint: ENDPIONTS.payrollSuspensions,
      id: payrollId,
    },
    new PaginatedResult<PayrollSuspensionResponseDTO>()
  );

  useEffect(() => {}, [fetchData?.isFetching]);

  const headers: ComplexHeader[] = [
    { key: "employeeName", title: "Name" },
    { key: "period", title: "period" },
    { key: "remarks", title: "remarks" },
  ];

  return (
    <div className="col-12">
      <h3>Suspended Employees</h3>
      <hr />

      <Table
        class="table table-striped table-hover mb-0"
        data={fetchData?.data ?? []}
        headers={headers}
        isFetchingPage={fetchData.isFetching}
        showCounter
      />
    </div>
  );
};

export default PayrollSuspensions;
